exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-member-avatar{display:inline-block;background-size:cover;width:32px;height:32px;background-position:50%;margin-right:4px;border-radius:50%!important}.user-column .img-member-avatar,.user-column .user-name{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06a7e0bd","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/metronic/table/value/CreatedBy.vue
// module id = MzeI
// module chunks = 0 1 2